/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteAllTimesRegForDayInput = {|
  ids?: ?$ReadOnlyArray<?string>,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type deleteAllTimeRegistrationsForDayMutationVariables = {|
  input: DeleteAllTimesRegForDayInput
|};
export type deleteAllTimeRegistrationsForDayMutationResponse = {|
  +deleteAllTimeRegsForDay: ?{|
    +deletedTimeRegIds: ?$ReadOnlyArray<?string>,
    +viewer: ?{|
      +id: string
    |},
    +errors: ?$ReadOnlyArray<?string>,
  |}
|};
export type deleteAllTimeRegistrationsForDayMutation = {|
  variables: deleteAllTimeRegistrationsForDayMutationVariables,
  response: deleteAllTimeRegistrationsForDayMutationResponse,
|};
*/


/*
mutation deleteAllTimeRegistrationsForDayMutation(
  $input: DeleteAllTimesRegForDayInput!
) {
  deleteAllTimeRegsForDay(input: $input) {
    deletedTimeRegIds
    viewer {
      id
    }
    errors
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteAllTimesRegForDayInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteAllTimesRegForDayPayload",
    "kind": "LinkedField",
    "name": "deleteAllTimeRegsForDay",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedTimeRegIds",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteAllTimeRegistrationsForDayMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteAllTimeRegistrationsForDayMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deleteAllTimeRegistrationsForDayMutation",
    "operationKind": "mutation",
    "text": "mutation deleteAllTimeRegistrationsForDayMutation(\n  $input: DeleteAllTimesRegForDayInput!\n) {\n  deleteAllTimeRegsForDay(input: $input) {\n    deletedTimeRegIds\n    viewer {\n      id\n    }\n    errors\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '56a8a94398bb87ce883199b138b46bbd';

module.exports = node;
